// extracted by mini-css-extract-plugin
export default {"asideContainer":"styles_asideContainer__V07kZ"};